<template>
  <div class="news-page together-page">
	<Header></Header> <!-- 头部 -->
    <div class="content home_lists">
		<van-tabs @click="onApply" v-model="joa_activeTabName">
    	  <van-tab v-for="(item_tabs,i) in tabs_lists" :name="item_tabs">
			<div v-if="i==0" class="ten-year" slot="title">
			<!-- <i class="van-icon van-icon-fire vtop"></i> -->
			<van-image
			  style="margin-top:5px;"
			  width="92"
			  height="32"WEB_URL
			  :src="WEB_URL+'images/ten.png'"
			/>
			</div>
    		<div v-else slot="title" style="margin-top:10px;">{{item_tabs}}</div>
			<div>
    			<van-list
    			  v-model="joa_loading"
    			  :finished="joa_finished"
    			  finished-text=" "
    			>
    				<div class="news_lists allshow" v-for="(item,index) in joa_list">
						<a :id="'lists_'+item.ID" @click="onSubmitRead(item.ID,item.READ_STATUS)" v-if="item.IS_FOREIGN_URL=='N' && item.IS_ATTACHMENT=='N'" :data-url="WEB_URL+'noticedetail?type=together&nid='+nid+'&id='+item.ID+source">
							<van-card>
    							<div slot="title" class="ntile">
    								<div :id="'read_'+item.ID" class="pl15">
    									<span v-if="item.READ_STATUS == 'Y'" class="dot"></span>
    									<span v-else class="dot red-dot"></span>
    									{{item.TITLE}}
    								</div>
    							</div>
    							<div slot="tags" class="mt5 mb10">
    								<!-- <van-tag plain type="primary">{{item.OWNER}}</van-tag> -->
									<span class="left c999 ml15">{{item.OWNER}}</span>
    								<span class="right c999">{{Common.toTimeDate(item.PUBLICDATE)}}</span>
    							</div>
    						</van-card>
    					</a>
						<a :id="'lists_'+item.ID" @click="onSubmitRead(item.ID,item.READ_STATUS)" v-else :data-url="item.DETAIL_URL">
							<van-card>
								<div slot="title" class="ntile">
									<div :id="'read_'+item.ID" class="pl15">
										<span v-if="item.READ_STATUS == 'Y'" class="dot"></span>
										<span v-else class="dot red-dot"></span>
										{{item.TITLE}}
									</div>
								</div>
								<div slot="tags" class="mt5 mb10">
									<!-- <van-tag plain type="primary">{{item.OWNER}}</van-tag> -->
									<span class="left c999 ml15">{{item.OWNER}}</span>
									<span class="right c999">{{Common.toTimeDate(item.PUBLICDATE)}}</span>
								</div>
							</van-card>
						</a>
    				</div>
    			</van-list>
    		</div>			
    	</van-tab>
     </van-tabs>	
	 <NoDatas></NoDatas> <!-- 没有数据-->	
<!--	 <FooterNews></FooterNews> &lt;!&ndash; 尾部 &ndash;&gt;-->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  created() {
	this.getData(this.nid);
  },
  data() {
    return {
	  WEB_URL:this.CoreNew.WEB_URL,
	  OA_API_URL:this.CoreNew.OA_API_URL,
	  CECPORT_IMG_URL:this.CoreNew.CECPORT_IMG_URL,
	  URLTOKEN:encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
	  joa_activeTabName:"文化社区",
	  //tabs_lists: ["跨越十年","文化社区","活动社区","沟通社区"],
	  tabs_lists: ["跨越十年","文化社区","活动社区"],
	  joa_list : [],
	  joa_list_Care : [],
	  joa_list_Periodical : [],
	  joa_list_Activity : [],
	  joa_total:0,
	  joa_page:0,
	  joa_loading: false,
	  joa_finished: false,
	  nid:this.CoreNew.SYSTABLE.TOGETHER_CULTURE,
	  ntype:"CULTURE", //活动社区
		source:''
	}
  },
	mounted(){
		if(this.CoreNew.WEB_URL_SOURCE){
			this.source='&source='+this.CoreNew.WEB_URL_SOURCE
		}
	},
  methods:{
	  onSubmitRead: function (id,read_status) { //更新阅读状态
	    var url=$("#lists_"+id).attr("data-url");
		var a_url="";
		if(url.indexOf("filePath=")>0){
			let reg=new RegExp('https://portal.cecport.com/redirect?','g')//g代表全部
			var url_file=url.replace(reg,this.OA_API_URL+"joa-business/attach/downloadToPath");
		}else{
			a_url=url;
		}	
		if(read_status=="N"){
	  		let json_data = {"ENTITY_CONFIG_ID":this.CoreNew.SYSTABLE.TOGETHER_CULTURE,"MESSAGE_ID":id,"USER_ID":localStorage.getItem('LS_ADMIN_USER_ID')};
	  		axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/697/",json_data,{
	  			headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
	  		}).then(function (response) {
	  			var $rs=response.data;
	  			if(url.indexOf("filePath=")>0){  //附件
	  				$("#loading").show();
	  				this.Common.onFiles(a_url);
	  			}else{
	  				window.location.href=a_url; //跳转
	  			}
	  		}.bind(this)).catch(function (error) { 
	  			$("#loading").hide();
	  			//alert("请求--文章--阅读状态--失败"+error);
	  			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--文章--阅读状态--失败"+error);//记录错误
	  			console.log("请求--文章--阅读状态--失败"+error);
	  		});
	  	}else{
			if(url.indexOf("filePath=")>0){
				$("#loading").show();
				this.Common.onFiles(a_url);
			}else{
				window.location.href=a_url; //跳转
			}
	  	}
	  },
	  onApply: function (name,title) {
		this.joa_list_Care=[];this.joa_list_Periodical=[];this.joa_list_Activity=[];
		this.joa_list=[];
		$(".no-datas").removeClass("show");
	  	if(name=="跨越十年"){
			this.ntype="CARE";this.nid=this.CoreNew.SYSTABLE.TOGETHER_CARE;
			this.joa_page=0;this.getData(this.nid);
	  	}else if(name=="文化社区"){ //文化社区
			this.ntype="CULTURE";this.nid=this.CoreNew.SYSTABLE.TOGETHER_CULTURE;
			this.joa_page=0;this.getData(this.nid); 
	  	}else if(name=="活动社区"){ //活动社区
			this.ntype="ACTIVITY";this.nid=this.CoreNew.SYSTABLE.TOGETHER_ACTIVITY;
			this.joa_page=0;this.getData(this.nid); 
	  	}else{
			//window.location.href=this.WEB_URL+'zyqbbs/';
			window.location.href='https://mb.cecport.com/zyqbbs/'+source;
		}
	  },
	  onLoad: function () {
	  	this.getData(this.nid); //获取数据	
	  },
	  getData: function (nid) {
		//alert(encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))));
		this.joa_page++;this.joa_loading = true;
	    //let json_data = {"TYPE":ntype};
		let json_data = {};
		axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+nid+"/"+this.joa_page+"/"+this.CoreNew.PAGESIZE+"/",json_data,{
			headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
		}).then(function (response) {
			if(response.data.flag==true){
				if(response.data.data.total==0){
					this.joa_list=[];
					this.joa_loading = false;this.joa_finished = true;
					$(".no-datas").addClass("show");
				}else{
					var $rs=response.data
					$(".no-datas").removeClass("show");
					this.joa_total=$rs.data["total"];
					var $list=$rs.data["records"];
					if(nid==this.CoreNew.SYSTABLE.TOGETHER_CARE){
						this.joa_list_Care=this.joa_list_Care.concat($list);
						var length=this.joa_list_Care.length;
						this.joa_list=this.joa_list_Care;
					}else if(nid==this.CoreNew.SYSTABLE.TOGETHER_CULTURE){
						this.joa_list_Periodical=this.joa_list_Periodical.concat($list);
						var length=this.joa_list_Periodical.length;
						this.joa_list=this.joa_list_Periodical;
					}else if(nid==this.CoreNew.SYSTABLE.TOGETHER_ACTIVITY){
						this.joa_list_Activity=this.joa_list_Activity.concat($list);
						var length=this.joa_list_Activity.length;
						this.joa_list=this.joa_list_Activity;
					}
					// 数据全部加载完成
					this.joa_loading = false;
					if (length !=0 && (length >= this.joa_total)) {
					 this.joa_finished = true;
					}else{
						this.getData(nid); //获取数据
					}
				}
			}
	    }.bind(this)).catch(function (error) { 
			//alert("请求--在一起--失败"+error);
			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--在一起--失败"+error);//记录错误
			console.log("请求--在一起--失败"+error); 
	    });
	  }
  }
};
</script>